import { useEffect } from "react";
import { Alert, Badge, Button, Col, Row } from "react-bootstrap";
import Icon from "@mdi/react";
import { mdiCheckboxBlankOutline, mdiCheckboxMarkedOutline } from "@mdi/js";

import { CriteriaManifestationEntity } from "src/entities/CriteriaManifestationEntity";
import { CriteriaGroupEntity } from "src/entities/CriteriaGroupEntity";
import { CriteriaClassificationEntity } from "src/entities/CriteriaClassificationEntity";

type ManifestationsStepProps = {
	options: CriteriaManifestationEntity[];
	selectedGroups: CriteriaGroupEntity[];
	selectedClassifications: CriteriaClassificationEntity[];
	selectedOptions: CriteriaManifestationEntity[];
	onChange: (selectedOptions: CriteriaManifestationEntity[]) => void;
	onCanAdvanceChange: (canAdvance: boolean) => void;
};

export default function ManifestationsStep({
	options,
	selectedGroups,
	selectedClassifications,
	selectedOptions,
	onChange,
	onCanAdvanceChange,
}: ManifestationsStepProps) {
	const filteredOptions = options.filter((manifestation) => {
		const matchesGroups = selectedGroups.length === 0 || manifestation.groups.some((group) => selectedGroups.some((selected) => selected.id === group.id));
		const matchesClassifications =
			selectedClassifications.length === 0 ||
			manifestation.classifications.some((classification) => selectedClassifications.some((selected) => selected.id === classification.id));

		return matchesGroups && matchesClassifications;
	});
	
	const hasActiveFilters = selectedGroups.length > 0 || selectedClassifications.length > 0;

	useEffect(() => {
		onCanAdvanceChange(selectedOptions.length > 0);
	}, [onCanAdvanceChange, selectedOptions.length]);

	function handleToggle(manifestation: CriteriaManifestationEntity) {
		onChange(
			selectedOptions.some((option) => option.id === manifestation.id)
				? selectedOptions.filter((option) => option.id !== manifestation.id)
				: [...selectedOptions, manifestation]
		);
	}

	return (
		<Row className="w-100">
			{hasActiveFilters && (
				<Col md={12} className="d-flex flex-wrap align-items-center gap-2 mb-3">
					{selectedGroups.length > 0 && (
						<Badge bg="light" text="dark" className="border px-3 py-2 fw-normal">
							Grupos: <strong>{selectedGroups.map((group) => group.title).join(", ")}</strong>
						</Badge>
					)}
					{selectedClassifications.length > 0 && (
						<Badge bg="light" text="dark" className="border px-3 py-2 fw-normal">
							Classificações: <strong>{selectedClassifications.map((classification) => classification.title).join(", ")}</strong>
						</Badge>
					)}
				</Col>
			)}
			{filteredOptions.length === 0 ? (
				<Col md={12}>
					<Alert variant="light" className="mb-0">
						Nenhuma manifestação encontrada para os grupos e classificações selecionados.
					</Alert>
				</Col>
			) : (
				filteredOptions.map((manifestation) => {
					const checked = selectedOptions.some((option) => option.id === manifestation.id);

					return (
						<Col key={manifestation.id} md={12} className="mb-2">
							<Button
								type="button"
								variant="outline-dark"
								className={`d-flex align-items-center w-100 gap-3 rounded-3 border text-start h-100 ${checked ? "active" : ""}`}
								onClick={() => handleToggle(manifestation)}
							>
								<div>
									<Icon path={checked ? mdiCheckboxMarkedOutline : mdiCheckboxBlankOutline} size={1} />
								</div>
								{manifestation.title}
							</Button>
						</Col>
					);
				})
			)}
		</Row>
	);
}
